import "toastify-js/src/toastify.css"
import Toastify from 'toastify-js'
export default function() {
    document.querySelectorAll('.alert.alert-toast').forEach( $element => {
        $element.style.display = "none";

        Toastify({
            text: String($element.innerHTML).trim(),
            style: {
                background: "linear-gradient(90deg, rgba(51,168,37,1) 0%, rgba(74,172,49,1) 38%, rgba(41,148,31,1) 100%)"
            }
        }).showToast();
    })
}
